import * as React from "react"
import { Flex, Text } from "@chakra-ui/react"
import { CommonInput } from "../../../common/fields"
import { SelectField } from "../../../common/fields/select-field"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { useTranslation } from "react-i18next"

interface SearchBarProps {
  value: { textField: string; optionSort: string }
  setValue: any
  customOptions?: any
}

//highest price/ lowest price / alphabetically

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  setValue,
  customOptions
}) => {
  const { t } = useTranslation()

  const options = [
    { value: "highestPrice", label: t("Highest price") },
    { value: "lowestPrice", label: t("Lowest price") },
    { value: "alphabetically", label: t("Alphabetically") }
  ]
  const roomStyles = useRecoilValue(brandingSelector)

  const handleChange = e => {
    e.preventDefault()
    setValue(prev => {
      return { ...prev, textField: e.target.value }
    })
  }

  const onChangeSelect = data => {
    setValue(prev => {
      return { ...prev, optionSort: data!.value }
    })
  }

  return (
    <Flex p="1rem 1rem 0rem 1rem">
      <CommonInput
        placeholder={t("Search...")}
        value={value.textField}
        onChange={handleChange}
        width="5rem"
        marginRight="0.8rem"
        stylesContainer={{ width: "unset" }}
        height="2.1875rem"
        fontSize="0.875rem"
        paddingInlineStart="7px"
        paddingInlineEnd="7px"
      />
      <Flex width="100%">
        <Flex alignItems="center" marginRight="0.5rem">
          <Text
            whiteSpace="nowrap"
            fontSize="0.9rem"
            fontWeight="700"
            lineHeight="1"
            maxWidth="110px"
            overflow="hidden"
            textOverflow="ellipsis"
            color={roomStyles?.servicePanelColorLabels ?? "black"}
          >
            {t("Sort by")}
          </Text>
        </Flex>
        <SelectField
          /*  selectedOption={selectedOption} */
          onChange={onChangeSelect}
          isSearchable={false}
          options={customOptions ?? options}
          customStyles={{
            menu: {
              width: "150px !important",
              right: "0px !important"
            },
            indicatorSeparator: { display: "none" },
            indicatorsContainer: { padding: "0px !important" },
            indicatorContainer: { padding: "4px" },
            dropdownIndicator: { padding: "4px" },
            valueContainer: { padding: "0px 2px 0px 0px" },
            placeholder: { fontSize: "0.875rem", marginLeft: "7px" },
            singleValue: { fontSize: "0.875rem", marginLeft: "7px" },
            menuList: { fontSize: "0.875rem" },
            option: { fontSize: "0.875rem" },
            control: { minHeight: "35px" },
            input: {
              paddingTop: "0px",
              paddingBottom: "0px",
              fontSize: "0.875rem"
            }
          }}
        />
      </Flex>
    </Flex>
  )
}

export default SearchBar
